import React, { useState, useEffect, useReducer } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
  CardText,
  UncontrolledTooltip,
} from "reactstrap"
import Tab from "react-bootstrap/Tab"
import Tabs from "react-bootstrap/Tabs"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
import ReactModal from "react-modal-resizable-draggable"
import "./video.scss"
//redux
import { useSelector, useDispatch } from "react-redux"

import { useHistory, useParams, withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import {
  fetchAppointmentsBasedOnId,
  updateVet,
  updateVisit,
  updatePrescription,
} from "helpers/api_helper"
import ButtonMain from "components/Common/Button"
import {
  calculateWeeksOfBirth,
  getDateDDMMYYYY,
  getDateTime,
  getAppointmentConsultationMode,
  isVirtualAppointment,
  modifyAppointmentType,
} from "helpers/utils"
import Type from "./Type"
import Medicines from "./Medicines"
import ReactSelect from "react-select"
import {
  fetchAppointmentTypes,
  fetchMedicines,
  getAppointments,
  getServices,
  getTodaysAppointments,
  getUserDetails,
  setGlobalLoading,
} from "store/slices"
import { showMessage } from "components/Notification"

import ImagingTest from "./OtherRequests/ImagingTest"
import LabTest from "./OtherRequests/LabTest"
import VacinationTest from "./OtherRequests/Vacination"

import VideoChat from "pages/VideoScreens/VideoChat"
import { useCall } from "context/CallContext"
import classNames from "classnames"
import VacinationForm from "./OtherRequests/Vacination";
import appConstants from "../../constants/appConstants/appConstants.json";
import PrescriptionImagingAndLabTestListing from "components/Common/PrescriptionImagingAndLabTestListing"
import AppointmentAttachments from "./components/AppointmentAttachments"

const UserProfile = () => {
  //meta title
  document.title = "Profile | Supaw"

  const dispatch = useDispatch()

  const [key, setKey] = useState("Medicines")
  const [isLoading, setIsLoading] = useState(false)
  const [appointment, setAppointment] = useState({})
  const [appointmentError, setAppointmentError] = useState("")
  const [medicines, setMedicines] = useState([])
  const [Vaccines, setVaccines] = useState([])
  const [modalIsOpen, setVideoModalState] = useState(false)
  const [isFullScreen, setFullScreen] = useState(false)
  const { joined, callViewMode, setPendingRestore, pendingRestore, setCallViewMode } = useCall()
  const userDetails = useSelector(getUserDetails)
  const [relationIds, setRelationalIds] = useState({})
  const [diagnosisIds, setDiagnosisIds] = useState([])
  const [imagingTestValuesArray, setImagingTestValuesArray] = useState([])
  const [labTestValuesArray, setLabTestValuesArray] = useState([])

  // ─── Validation error state ───────────────────────────────────────────────
  const [validationErrors, setValidationErrors] = useState({})

  const handleImagingTestValues = values => {
    setImagingTestValuesArray(prevValues => [...prevValues, values])
  }
  const handleLabTestValues = values => {
    setLabTestValuesArray(prevValues => [...prevValues, values])
  }

  const { id } = useParams()

  const reducer = (state, action) => {
    switch (action.type) {
      case "edit":
        return { ...state, [action.payload.name]: action.payload.value }
      default:
        return state
    }
  }

  const [values, dispatchReducer] = useReducer(reducer, {
    notes: "",
  })

  const stateChange = name => e => {
    const _value = e.target.value
    // Clear validation error for notes when user starts typing
    if (name === "notes") {
      setValidationErrors(prev => ({ ...prev, notes: null }))
    }
    dispatchReducer({ type: "edit", payload: { name, value: _value } })
  }

  const history = useHistory()

  useEffect(() => {
    async function fetch() {
      if (id) {
        dispatch(setGlobalLoading(true))
        try {
          const response = await fetchAppointmentsBasedOnId(id)
          if (response?.status !== 1 || !response?.data?._id) {
            setAppointment({})
            setAppointmentError(response?.message || "Unable to load this appointment.")
            return
          }
          setAppointmentError("")
          if (response.data.status !== "checkIn") {
            history.push(`/checkin/${id}`)
            return
          }
          setAppointment(response.data)
          dispatchReducer({ type: "edit", payload: { name: "notes", value: response.data.notes || "" } })
          setKey(
            response.data.visitType == "Vaccination"
              ? "Vaccination"
              : "Medicines"
          )

          const obj = {}
          obj.petObjectId = response?.data?.petObjectId?._id
          obj.parentId = response?.data?.petObjectId?.parentId
          obj.doctorId = response?.data?.doctorId?._id
          console.log(response.data)
          const _diagnosisIds = response?.data?.primaryDiagnosis?.map(
            el => el.id
          )
          setDiagnosisIds(_diagnosisIds)
          setRelationalIds(obj)
        } catch (error) {
          setAppointment({})
          setAppointmentError("Unable to load this appointment.")
        } finally {
          dispatch(setGlobalLoading(false))
        }
      }
      dispatch(fetchAppointmentTypes())
    }
    fetch()
  }, [dispatch])

  useEffect(() => {
    if (pendingRestore && appointment?._id) {
      setCallViewMode("original")
      setPendingRestore(false)
    }
  }, [pendingRestore, appointment?._id, setCallViewMode, setPendingRestore])

  const handleFullScreen = () => {
    setFullScreen(current => !current)
  }

  if (!id || !appointment?._id) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumb title="Appointments" breadcrumbItem="Prescription" />
            <Row>
              <Card>
                <CardBody>
                  <CardText role={appointmentError ? "alert" : undefined}>
                    {appointmentError || "Loading appointment..."}
                  </CardText>
                </CardBody>
              </Card>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }

  // ─── Validation logic ─────────────────────────────────────────────────────
  const validateForm = () => {
    const errors = {}
    const isVaccinationVisit = appointment?.visitType === "Vaccination"

    // ── 1. Notes are always required ──────────────────────────────────────
    if (!values.notes || !values.notes.trim()) {
      errors.notes = "Notes / observations are required."
    }

    // ── 2. Medicines tab: at least one valid medicine must be added ────────
    if (!isVaccinationVisit) {
      if (!medicines.length) {
        errors.medicines = "Please add at least one medicine."
      } else {
        const incompleteIndex = medicines.findIndex(
          ({ medicine, dosage, duration }) => !medicine || !dosage || !duration
        )
        if (incompleteIndex !== -1) {
          errors.medicines = `Medicine entry ${incompleteIndex + 1} is incomplete. Please fill all required fields (medicine, dosage, duration).`
        }
      }
    }

    // ── 3. Vaccination tab: at least one valid vaccine must be added ───────
    if (isVaccinationVisit) {
      if (!Vaccines.length) {
        errors.vaccines = "Please add at least one vaccine."
      } else {
        const incompleteVaccIndex = Vaccines.findIndex(
          ({ vaccine, type, DOV, EOV }) => !vaccine?.value || !type || !DOV || !EOV
        )
        if (incompleteVaccIndex !== -1) {
          errors.vaccines = `Vaccine entry ${incompleteVaccIndex + 1} is incomplete. Please fill all required fields (vaccine, type, date of vaccination, expiry date).`
        }
      }
    }

    return errors
  }

  const handleSubmit = async () => {
    try {
      // Run validation
      const errors = validateForm()

      if (Object.keys(errors).length > 0) {
        setValidationErrors(errors)

        // Show the first error as a toast/notification
        const firstError = Object.values(errors)[0]
        showMessage({ label: firstError, status: "error" })

        // Switch to the relevant tab if there's a medicine or vaccine error
        if (errors.medicines) setKey("Medicines")
        if (errors.vaccines) setKey("Vaccination")

        return
      }

      // Clear any previous errors
      setValidationErrors({})
      setIsLoading(true)

      const obj = {
        medicines,
        notes: values.notes,
        imagingTests: imagingTestValuesArray,
        labTests: labTestValuesArray,
        vaccinations: Vaccines.map(it => ({
          vaccine: it.vaccine.value,
          type: it.type,
          date: it?.DOV,
          expiryDate: it?.EOV,
        })),
      }

      const response = await updatePrescription(id, obj)
      if (response?.status == 1) {
        showMessage({
          label: "Prescription created successfully",
          status: "success",
        })
        dispatch(getTodaysAppointments())
        history.push(`/prescription-details/${id}`)
      }
    } catch (error) {
      console.error("Error in UserProfile:handleSubmit:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleAddMed = data => {
    console.log(data, "data")
    setMedicines(data)
    // Clear medicine error when user adds/updates medicines
    if (data.length > 0) {
      setValidationErrors(prev => ({ ...prev, medicines: null }))
    }
  }

  const handleAddVac = data => {
    console.log(data, "dddaartttaa")
    setVaccines(data)
    // Clear vaccine error when user adds/updates vaccines
    if (data.length > 0) {
      setValidationErrors(prev => ({ ...prev, vaccines: null }))
    }
  }

  const BackButton = () => {
    window.history.back()
  }

  const addressSnapshot = appointment?.addressSnapshot
  const addressText = addressSnapshot && typeof addressSnapshot === "object"
    ? [
        addressSnapshot.addressLine || addressSnapshot.addressLine1 || addressSnapshot.address,
        addressSnapshot.addressLine2 || addressSnapshot.area,
        addressSnapshot.landmark,
        addressSnapshot.city,
        addressSnapshot.state,
        addressSnapshot.pinCode || addressSnapshot.pincode || addressSnapshot.postalCode,
      ].filter(Boolean).join(", ")
    : typeof addressSnapshot === "string" ? addressSnapshot.trim() : ""
  const appointmentAttachments = Array.isArray(appointment?.attachments) ? appointment.attachments : []

  const renderCells = type => {
    const array = appointment?.primaryDiagnosis?.filter(el => el.type === type)
    return (
      <div className="cell-tag-container">
        {array?.length ? (
          <>
            <h6>
              {type === "primary" ? "Primary Diagnosis" : "Secondary Diagnosis"}:
            </h6>
            <div className="cell-tags-roe">
              {array.map(({ title }, index) => (
                <div key={`${title}-${index}`} className="cell-tags">
                  {title}
                </div>
              ))}
            </div>
          </>
        ) : null}
      </div>
    )
  }

  const renderAllergies = () => {
    return (
      <div className="cell-tag-container">
        {appointment?.patientAllergies?.length ? (
          <div className="cell-tags-roe">
            {appointment.patientAllergies.map(({ title }, index) => (
              <div key={`${title}-${index}`} className="cell-tags">
                {title}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    )
  }

  const handleOpenVideo = () => {
    var body = document.body
    // body.classList.add("vertical-collpsed")
    // body.classList.remove("sidebar-enable")
    setVideoModalState(true)
  }

  const consultationMode = getAppointmentConsultationMode(appointment)
  const isVirtualVisit = isVirtualAppointment(appointment)

  const handleOnEnd = () => {
    setVideoModalState(false)
  }

  const deleteClickHandler = item => {
    if (item.testType === appConstants.IMAGING) {
      const imagingsArray = imagingTestValuesArray.filter(i => i.type !== item.type)
      setImagingTestValuesArray(imagingsArray)
    } else if (item.testType === appConstants.LAB_TEST) {
      const labTestsArray = labTestValuesArray.filter(i => i.title !== item.type)
      setLabTestValuesArray(labTestsArray)
    }
  }

  const renderPrescriptionForm = () => {
    return (
      <Form
        className="form-horizontal row"
        onSubmit={e => {
          e.preventDefault()
          return false
        }}
      >
        <Col lg={6}>
          <div className="row">
            <Label
              htmlFor="projectdesc"
              className="col-form-label col-lg-5 text-left text-input-label font-fontFamily"
            >
              Checkin:
            </Label>
            <div className="col-lg-7">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily"
              >
                {getDateTime(appointment?.checkIn)}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Primary Diagnosis:
            </Label>
            <div className="col-lg-7">
              {renderCells("primary")}
              {renderCells("secondary")}
            </div>
          </div>

          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Patient Allergies:
            </Label>
            <div className="col-lg-7">{renderAllergies()}</div>
          </div>
          <div className="row">
            <Label
              htmlFor="projectdesc"
              className="col-form-label col-lg-5 text-left text-input-label font-fontFamily"
            >
              Name:
            </Label>
            <div className="col-lg-7">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily"
              >
                {appointment?.petObjectId?.fullName}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Type:
            </Label>
            <div className="col-lg-7">
              <Label className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily">
                {appointment?.petObjectId?.petType}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Breed:
            </Label>
            <div className="col-lg-7">
              <Label className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily">
                {appointment?.petObjectId?.petBreed}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Gender:
            </Label>
            <div className="col-lg-7">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily"
              >
                {appointment?.petObjectId?.gender}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Date of Birth:
            </Label>
            <div className="col-lg-7">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-8 text-primary text-left text-input-label-value font-fontFamily"
              >
                {getDateDDMMYYYY(appointment?.petObjectId?.dateOfBirth)}
              </Label>
            </div>
          </div>
          <div className="row">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Reason For Visit:
            </Label>
            <div className="col-lg-7">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-7 text-primary text-left text-input-label-value font-fontFamily"
              >
                {appointment.reasonForVisit}
              </Label>
            </div>
          </div>

          <div className="row mt-3">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Customer Address:
            </Label>
            <div className="col-lg-7">
              <div className="text-primary text-input-label-value font-fontFamily" style={{ whiteSpace: "pre-wrap" }}>
                {addressText || "Not provided"}
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Pet Problem / Concern:
            </Label>
            <div className="col-lg-7">
              <div className="text-primary text-input-label-value font-fontFamily" style={{ whiteSpace: "pre-wrap" }}>
                {appointment?.problem || "Problem not provided"}
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <Label className="col-form-label col-lg-5 text-left text-input-label font-fontFamily">
              Reports / Images / Attachments:
            </Label>
            <div className="col-lg-7">
              <AppointmentAttachments appointmentId={appointment?._id} attachments={appointmentAttachments} />
            </div>
          </div>

          {/* ── Notes field with validation ── */}
          <div className="row mt-3">
            <Label
              htmlFor="notes"
              className="col-form-label col-lg-5 text-left text-input-label font-fontFamily"
            >
              Notes / Observations <span className="text-danger">*</span>
            </Label>
            <div className="col-lg-7">
              <Input
                type="textarea"
                id="notes"
                rows={4}
                value={values.notes || ""}
                onChange={stateChange("notes")}
                invalid={!!validationErrors.notes}
                placeholder="Enter clinical notes or observations..."
                className="font-fontFamily"
              />
              {validationErrors.notes && (
                <FormFeedback type="invalid">
                  {validationErrors.notes}
                </FormFeedback>
              )}
            </div>
          </div>
        </Col>

        <Col lg={6}>
          <div className="col-lg-4" />
          <div className="col-lg-6 d-flex justify-content-end h-[2rem]">
            <span className="gray-note font-fontFamily">
              Unique Id:{" "}
              <span className="gray-note--primary font-fontFamily">
                {appointment?.petObjectId?.petId}
              </span>
            </span>
          </div>
          <br />
          <br />
        </Col>

        {!joined && !modalIsOpen && (
          <>
          {isVirtualVisit && (
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ButtonMain
                onClick={handleOpenVideo}
                style={{ maxWidth: 120 }}
                className="btn btn-small btn-secondary btn-secondary2 mx-4"
              >
                Start {consultationMode === "audio" ? "Audio" : "Video"} Call
              </ButtonMain>
            </div>
          )}
          </>
        )}

        <hr />
        <h4 className="mb-sm-0 font-fontFamily fontSize-24">Basic Vitals</h4>
        <Row className="mt-20">
          <Col lg={5}>
            <FormGroup className="mb-4 row">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-5 text-left text-input-label font-fontFamily"
              >
                Weight
              </Label>
              <div className="col-lg-7">
                <Label
                  htmlFor="projectdesc"
                  className="col-form-label col-lg-8 text-primary text-left text-input-label font-fontFamily"
                >
                  {appointment?.basicVitals?.weight} Kg.
                </Label>
              </div>
            </FormGroup>
          </Col>
          <Col lg={7}>
            <FormGroup className="row mb-9">
              <Label
                htmlFor="projectdesc"
                className="col-form-label col-lg-5 text-left text-input-label text-input-label--md font-fontFamily"
              >
                Temperature
              </Label>
              <div className="col-lg-7">
                <Label
                  htmlFor="projectdesc"
                  className="col-form-label col-lg-8 text-primary text-left text-input-label font-fontFamily"
                >
                  {appointment?.basicVitals?.temperature} degree (c)
                </Label>
              </div>
            </FormGroup>
          </Col>
        </Row>

        <Col lg={12}>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={k => setKey(k)}
            className="mb-3"
          >
            {/* ── Medicines Tab ── */}
            <Tab eventKey="Medicines" title="Medicines">
              <h4 className="mb-sm-0 font-fontFamily fontSize-24">
                Medicines <span className="text-danger">*</span>
              </h4>
              {validationErrors.medicines && (
                <Alert color="danger" className="mt-2 mb-2 font-fontFamily">
                  {validationErrors.medicines}
                </Alert>
              )}
              <Medicines ids={diagnosisIds} onConfirm={handleAddMed} selectedMedicines={medicines} />
            </Tab>

            {/* ── Vaccination Tab ── */}
            <Tab eventKey="Vaccination" title="Vaccination">
              <h4 className="mb-sm-0 font-fontFamily fontSize-24">
                Vaccines <span className="text-danger">*</span>
              </h4>
              {validationErrors.vaccines && (
                <Alert color="danger" className="mt-2 mb-2 font-fontFamily">
                  {validationErrors.vaccines}
                </Alert>
              )}
              <VacinationForm
                ids={diagnosisIds}
                agegroup={calculateWeeksOfBirth(
                  appointment?.petObjectId?.dateOfBirth
                )}
                petType={appointment?.petObjectId?.petType}
                onConfirm={handleAddVac}
              />
            </Tab>
          </Tabs>
        </Col>

        <Col lg={12}>
          <hr />
          <h4 className="mb-4 font-fontFamily fontSize-24">Others</h4>
          <ImagingTest
            relationIds={relationIds}
            onImagingTestValues={handleImagingTestValues}
            id={id}
          />
          <LabTest
            relationIds={relationIds}
            onLabTestValues={handleLabTestValues}
            id={id}
          />
        </Col>

        <Col lg={12}>
          <hr />
          <PrescriptionImagingAndLabTestListing
            data={[
              ...imagingTestValuesArray.map(item => ({
                ...item,
                testType: appConstants.IMAGING,
              })),
              ...labTestValuesArray.map(item => ({
                type: item?.title,
                notes: item?.instructions,
                testType: appConstants.LAB_TEST,
              })),
            ]}
            deleteClickHandler={deleteClickHandler}
          />
        </Col>

        <Row className="justify-content-end mt-8">
          <ButtonMain
            className="btn btn-secondary btn-med"
            type="button"
            onClick={BackButton}
          >
            Cancel
          </ButtonMain>
          <ButtonMain
            isLoading={isLoading}
            className="btn btn-primary btn-med"
            type="button"
            onClick={handleSubmit}
          >
            Submit <i className="mdi mdi-arrow-down" id="edittooltip" />
          </ButtonMain>
        </Row>
      </Form>
    )
  }

  const shouldShowCallView =
  (modalIsOpen || joined) && callViewMode !== "minimized"

return (
  <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Supaw" breadcrumbItem="Prescription" />

        <Row>
          <Card>
            <CardBody>
              <Row>
                <Col lg={shouldShowCallView ? 9 : 12}>
                  {renderPrescriptionForm()}
                </Col>

                <Col
                    lg={3}
                    style={{
                      display: shouldShowCallView ? "block" : "none",
                      height: "calc(100vh - 200px)",
                      minHeight: 500,
                    }}
                  >
                    <div
                      className={classNames("video-container", {
                        "video-container--full": isFullScreen,
                      })}
                      style={{ height: "100%" }}   // ← add this
                    >
                    <VideoChat
                      onEnd={handleOnEnd}
                      onFullScreen={handleFullScreen}
                      isFullScreen={isFullScreen}
                      userName={userDetails?.fullName}
                      roomName={id || appointment?._id}
                      visitType={consultationMode}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </Container>
    </div>
  </React.Fragment>
)
}

export default withRouter(UserProfile)
